import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Optionnel : pour détecter la langue du navigateur

// Importer dynamiquement les fichiers de traduction pour chaque langue/namespace
// Note: Vite supporte import.meta.glob pour l'import dynamique
// Ajuster le chemin si la structure est différente
const locales = import.meta.glob('/src/locales/*/*.ts', { eager: true });

const resources: Record<string, Record<string, any>> = {};

// Construire la ressource pour i18next
for (const path in locales) {
  const pathParts = path.split('/');
  const lang = pathParts[pathParts.length - 2]; // 'en', 'fr', 'es'
  // Le nom du fichier sans .ts devient le namespace
  const namespace = pathParts[pathParts.length - 1].replace('.ts', ''); 
  
  // Log détaillé pour chaque fichier traité
  console.log(`[i18n] Processing ${path}: lang=${lang}, namespace=${namespace}`);

  if (!resources[lang]) {
    resources[lang] = {};
  }
  
  // Assurer que le module exporte un objet (par défaut ou nommé)
  const module = locales[path] as any; // Utiliser any pour flexibilité d'export
  if (module && typeof module === 'object') {
    // Si l'export principal est l'objet de traduction (souvent export default)
    if (module.default && typeof module.default === 'object') {
      resources[lang][namespace] = module.default;
    } else {
      // Sinon, supposer que l'objet exporté directement contient les traductions
       // Ou si les exports sont nommés, il faudrait les agréger ici
       console.warn(`[i18n] Translation file ${path} might not have a default export or expected structure. Using the module object directly.`);
       resources[lang][namespace] = module;
       // Log le contenu ajouté
       console.log(`[i18n] Added content for ${lang}/${namespace} (non-default):`, module);
    }
  } else {
     console.error(`[i18n] Failed to load translations from ${path}`);
  }
}

// Log spécifique pour fr/profile APRÈS la boucle
if (resources.fr && resources.fr.profile) {
  console.log("[i18n] Content for fr/profile BEFORE init:", JSON.stringify(resources.fr.profile).substring(0, 500) + "..."); // Log début du contenu
} else {
  console.error("[i18n] fr/profile resources NOT FOUND before init!");
}

console.log("[i18n] Constructed resources:", JSON.stringify(resources, null, 2)); // <-- Log resources

// Extraire TOUS les namespaces de la première langue
const firstLang = Object.keys(resources)[0];
const allNamespaces = firstLang ? Object.keys(resources[firstLang]) : ['common']; 

console.log("[i18n] Derived all namespaces:", allNamespaces); // <-- Log all namespaces

i18n
  // .use(LanguageDetector) // Décommenter pour utiliser la détection auto
  .use(initReactI18next) // Passe i18n down to react-i18next
  .init({
    resources,
    // lng: 'fr', // <-- Définir explicitement FR pour tester
    fallbackLng: 'fr', // Langue de repli si clé manquante dans la langue actuelle
    // Charger TOUS les namespaces trouvés par défaut
    ns: allNamespaces, 
    defaultNS: 'common', // Garder 'common' si la plupart des clés sont là
    // Ou changer pour un autre si plus pertinent, ou même supprimer si on utilise toujours la syntaxe ns:key
    fallbackNS: 'common', // Namespace de secours si un namespace chargé n'est pas trouvé

    debug: true, // <-- Activer le mode debug

    interpolation: {
      escapeValue: false, // React échappe déjà par défaut
    },
    
    // Options pour LanguageDetector (si utilisé)
    // detection: {
    //   order: ['path', 'navigator', 'localStorage', 'cookie'],
    //   lookupPath: 'lng', // Recherche /:lng/ dans l'URL
    //   caches: ['localStorage']
    // }
  });

// Log après initialisation complète
i18n.on('initialized', (options) => {
  console.log('[i18n] Initialized successfully.');
  console.log('[i18n] Current language:', i18n.language); // <-- Log langue active
  console.log('[i18n] Available languages:', Object.keys(i18n.services.resourceStore.data)); // <-- Log langues chargées
});

i18n.on('languageChanged', (lng) => {
  console.log('[i18n] Language changed to:', lng);
});

export default i18n; 